<template>
    <div>
        <!-- HEADER FOR ALL CLUSTERS -->
        <h1>eServices Cluster 💻</h1>
        <h4>The eServices Cluster is responsible for managing the organization's internal and external IM-related initiatives which involve systems and multimedia applications development.</h4>

        <h3>Positions:</h3>

        <h2><b>IT Products and Services Officer</b></h2>
        <h4>Trains as an apprentice under the Associate Vice President for IT Products and Services.</h4>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Works with and supports the Associate Vice President for IT Products and Services in their tasks and responsibilities, such as, but are not limited to:
                <ul>
                    <li>Managing post-project and client-related documents.</li>
                    <li>Safekeeping all legal documents of all projects within the cluster.</li>
                    <li>Making sure MOAs do not have any loopholes.</li>
                </ul>
            </li>
            <li>Can be assigned to project teams for the cluster's initiatives and projects.</li>
            <li>Can be deployed as a developer when deemed necessary</li>
        </ul>

        <h2><b>Systems Documentation Officer</b></h2>
        <h4>Trains as an apprentice under the Associate Vice President for Systems Documentation for certain purposes such as:</h4>
        <ul>
            <li>Creating and maintaining Git repositories.</li>
        </ul>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Works closely with and supports the Associate Vice President for Systems Documentation in their tasks and responsibilities, such as, but are not limited to:
                <ul>
                    <li>Creating manuals for projects</li>
                    <li>Conducting systems documentation</li>
                    <li>Maintaining processes of system development</li>
                </ul>
            </li>
            <li>Can be assigned to project teams for the cluster's initiatives and projects</li>
            <li>Can be deployed as a developer when deemed necessary</li>
        </ul>

        <h2><b>IT Skills Training and Evaluation Officer</b></h2>
        <h4>Trains as an apprentice under the Associate Vice President for IT Skills Training and Evaluation.</h4>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Works closely with and supports the Associate Vice President for IT Skills Training and Evaluation in their tasks and responsibilities, such as, but are not limited to:
                <ul>
                    <li>Organizing trainings and workshops.</li>
                    <li>Manning the online eServices Helpdesk.</li>
                </ul>
            </li>
            <li>Can be assigned to project teams for the cluster's initiatives and projects.</li>
            <li>Can be deployed as a developer when deemed necessary</li>
        </ul>
        
       <h2><b>eServices Developer Training Pool</b></h2>
       <h4>Trains as an officer under the eServices cluster.</h4>
       <h4>Responsibilities:</h4>
       <ul>
         <li>Helps the AVPs in all post-project and client-related documents.</li>
         <li>Trains as an apprentice under the AVPs</li>
         <li>Can be assigned to project teams for the cluster’s initiatives and projects.</li>
       </ul>
       
        <!-- BETA POSITIONS -->
        <!-- <h2><b>Associate Vice President for IT Products and Services (1)</b></h2>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Initiates, supervises, documents, and ensures the completion of service agreements and services contracts to clients (such as other student organizations and small start-up companies) the organization engages with</li>
            <li>Assists the Vice President for eServices in forging, strengthening, and maintaining good relationships with the organization’s clients to increase customer loyalty and service referrals</li>
            <li>Communicates with the clients regarding project status and responds quickly to client inquiries and requests</li>
            <li>Manages the processing and safekeeping of all legal documents, as well as post-project and client-related documents</li>
            <li>Acts as the intermediary between the Office of Student Activities (OSA) and MISA for MOA-related matters</li>
            <li>Ensures that the MOA does not have any loopholes and processes developers’ cuts upon project completion</li>
            <li>Ensures that cluster members have sufficient skills as required by systems development projects through skills evaluation efforts</li>
        </ul>

        <h2><b>Associate Vice President for Systems Documentation (2)</b></h2>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Spearheads all the required documentation for both users and systems of all eServices project</li>
            <li>Creates user manuals for each user for each project and ensures that technical terms are made understandable to the user</li>
            <li>Conducts system documentation for each project by creating a clear process of the development of each system</li>
            <li>Manages the Git account of the eServices</li>
            <li>Takes note of the important dates in the development of each system, and changes for each project after they have been deployed</li>
            <li>Trains, oversees, and communicates with the Systems Documentation officers in the cluster, and serves as the bridge between them and the Vice President for eServices</li>
        </ul>

        <h2><b>Associate Vice President for IT Skills Training and Evaluation (2)</b></h2>
        <h4>Responsibilities:</h4>
        <ul>
            <li>Trains, assists, monitors and evaluates members and their individual performance, participation, and involvement within the cluster</li>
            <li>Conducts skills training, seminars, and workshops for members of the organization for them to have the required skills and knowledge for project and product development</li>
            <li>Deploys and assigns the members and officers of the eServices Cluster to project teams based on the assessment of their skills</li>
            <li>Trains, oversees, and communicates with the IT Skills Training and Evaluation officers and the eServices Developer Pool in the cluster, and serves as the bridge between them and the Vice President for eServices</li>
        </ul>  -->

        <!-- FOOTNOTES? -->
        <br>
        <p></p>
        
    </div>
</template>

<script>
export default {
    name: 'PrimerEservs'
}
</script>

<style scoped>
h1{
    font-size: 4.5vw;
}
</style>


